import React, { useEffect, useState } from 'react';
import { BASE_URL } from '../config/api'; // Assuming BASE_URL is correctly defined in your config/api.js
import { useNavigate } from 'react-router-dom';
import jsPDF from 'jspdf'; // Import jsPDF
import 'jspdf-autotable'; // Import for table support
import * as XLSX from 'xlsx'; // Import xlsx for Excel export

const RepairingsList = () => {
    const [repairs, setRepairs] = useState([]);
    const [filteredRepairs, setFilteredRepairs] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const navigate = useNavigate();

    // Fetch repairs data on mount
    useEffect(() => {
        fetch(`${BASE_URL}repairs`)
            .then(response => response.json())
            .then(data => {
                if (data.status === 1) {
                    setRepairs(data.data);
                    setFilteredRepairs(data.data); // Set initial filtered repairs
                } else {
                    alert('Error fetching repairs');
                }
            })
            .catch(error => console.error('Error fetching repairs:', error));
    }, []);

    // Handle search term change
    const handleSearchChange = (event) => {
        const term = event.target.value;
        setSearchTerm(term);
    };

    // Handle date range change
    const handleDateChange = (start, end) => {
        setStartDate(start);
        setEndDate(end);
    };

    // Filter repairs by search term and date range (called when Apply Filter button is clicked)
 const filterRepairs = () => {
    let filtered = repairs.filter(repair => {
        const matchesSearch = repair.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            repair.description.toLowerCase().includes(searchTerm.toLowerCase());

        const repairDate = new Date(repair.date).setHours(0, 0, 0, 0); // Set the time to 00:00:00 for comparison

        // Set startDate and endDate to the same format (00:00:00) if they exist
        const start = startDate ? new Date(startDate).setHours(0, 0, 0, 0) : null;
        const end = endDate ? new Date(endDate).setHours(0, 0, 0, 0) : null;

        // Check if the repair date is within the selected date range
        const matchesDateRange = (!start || repairDate >= start) && (!end || repairDate <= end);

        return matchesSearch && matchesDateRange;
    });

    setFilteredRepairs(filtered);
};


    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = ('0' + date.getDate()).slice(-2); // Add leading zero if day < 10
        const month = ('0' + (date.getMonth() + 1)).slice(-2); // Add leading zero if month < 10
        const year = date.getFullYear(); // Get full year (YYYY)
        return `${day}/${month}/${year}`;
    };

    // Handle the edit navigation
    const handleEdit = (id) => {
        navigate(`/EditRepairing/${id}`); // Navigate to the Edit Repair page
    };

    // Handle deletion of a repair
    const handleDelete = (id) => {
        if (window.confirm("Are you sure you want to delete this repair?")) {
            fetch(`${BASE_URL}repairs/${id}`, {
                method: 'DELETE',
                headers: {
                    'Content-Type': 'application/json',
                },
            })
                .then(response => response.json())
                .then(data => {
                    if (data.status === 1) {
                        // Remove the deleted repair from the list
                        setRepairs(repairs.filter(repair => repair.id !== id));
                        setFilteredRepairs(filteredRepairs.filter(repair => repair.id !== id));
                    }
                })
                .catch(error => console.error('Error deleting repair:', error));
        }
    };

    // Export filtered repairs to PDF
    const handleExportPDF = () => {
        const doc = new jsPDF();

        // Add Title
        doc.text('Repair List', 14, 10); // Title at top of PDF

        // Prepare table data for PDF
        const tableData = filteredRepairs.map(repair => [
            repair.name || 'N/A',
            repair.description || 'N/A',
            new Date(repair.date).toLocaleDateString() || 'N/A',
            repair.image ? `${BASE_URL}${repair.image}` : 'No Image',
        ]);

        // Add table to PDF with autoTable
        doc.autoTable({
            head: [['Name', 'Description', 'Date', 'Image']],
            body: tableData,
        });

        // Save the PDF with a filename
        doc.save('repair_list.pdf');
    };

    // Export filtered repairs to Excel
    const handleExportExcel = () => {
        const worksheet = XLSX.utils.json_to_sheet(filteredRepairs.map(repair => ({
            Name: repair.name || 'N/A',
            Description: repair.description || 'N/A',
            Date: new Date(repair.date).toLocaleDateString() || 'N/A',
            Image: repair.image ? `${BASE_URL}${repair.image}` : 'No Image',
        })));

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Repair List");

        // Save the Excel file with a filename
        XLSX.writeFile(workbook, 'repair_list.xlsx');
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Repair List</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Repair Table */}
            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <div className="row">
                                    <div className="col-md-6">
                                    </div>
                                    <div className="col-md-6 text-end">
                                        <button className="btn btn-primary" onClick={() => navigate('/AddRepairing')}>Add Repair</button>
                                        {/* Export to PDF Button */}
                                        <button className="btn btn-secondary ms-2" onClick={handleExportPDF}>Export to PDF</button>
                                        {/* Export to Excel Button */}
                                        {/* <button className="btn btn-secondary ms-2" onClick={handleExportExcel}>Export to Excel</button> */}
                                    </div>
                                </div>
                            </div>
                            <div className="card-body">
                                {/* Search and Date Filters */}
                                

                                {/* Date Filter Section */}
                                <div className="row mb-3">
                                    <div className="col-md-4">
                                    <label htmlFor="searchTerm" className="form-label">Search by Name or Description</label>
                                    <input
                                        type="text"
                                        id="searchTerm"
                                        className="form-control"
                                        placeholder="Search repair details"
                                        value={searchTerm}
                                        onChange={handleSearchChange}
                                    />
                                </div>
                                    <div className="col-md-4">
                                        <label htmlFor="startDate" className="form-label">Start Date</label>
                                        <input
                                            type="date"
                                            id="startDate"
                                            className="form-control"
                                            value={startDate}
                                            onChange={(e) => handleDateChange(e.target.value, endDate)}
                                        />
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="endDate" className="form-label">End Date</label>
                                        <input
                                            type="date"
                                            id="endDate"
                                            className="form-control"
                                            value={endDate}
                                            onChange={(e) => handleDateChange(startDate, e.target.value)}
                                        />
                                    </div>
                                    <div className="col-md-4 mt-3">
                                        <button 
                                            className="btn btn-secondary"
                                            onClick={filterRepairs} // Apply the filter only on button click
                                        >
                                            Apply Date Filter
                                        </button>
                                    </div>
                                </div>

                                <div className="table-responsive">
                                    <table className="table table-lg">
                                        <thead>
                                            <tr>
                                                <th>Name</th>
                                                <th>Description</th>
                                                <th>Date</th>
                                                <th>Image</th>
                                                <th className="text-end">Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredRepairs.length > 0 ? (
                                                filteredRepairs.map(repair => (
                                                    <tr key={repair.id}>
                                                        <td>{repair.name || 'N/A'}</td>
                                                        <td>{repair.description || 'N/A'}</td>
                                                        <td>{formatDate(repair.date)}</td>
                                                        <td>
                                                            {repair.image ? (
                                                                <img
                                                                    src={`${BASE_URL}${repair.image}`}
                                                                    alt={repair.name}
                                                                    width="50"
                                                                    height="50"
                                                                    style={{ margin: '5px' }}
                                                                />
                                                            ) : (
                                                                'No Image'
                                                            )}
                                                        </td>
                                                        <td className="text-end">
                                                            <button className="btn btn-success" onClick={() => handleEdit(repair.id)}>Edit</button>
                                                            <button className="btn btn-danger ms-2" onClick={() => handleDelete(repair.id)}>Delete</button>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">No repairs found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default RepairingsList;
